function RoundSeparator() {
  return <div className="w-[6px] h-[6px] rounded-full bg-primary" />;
}

export default RoundSeparator;
